<template>
  <div id="resetPassword">
    <Background-Image url="ray-of-light.jpg" color="#3E2723"></Background-Image>
    <Navigation></Navigation>

    <div class="container-fluid">
      <div class="row">
        <div class="offset-md-3 col-md-6 m-t-6">
          <div id="UserRecover" class="m-t-6">

            <div class="card padded p-b-2">
              <div v-if="isChanged" class="card-block">

                <!--Header-->
                <div class="form-header brown darken-2">
                  <h3> {{t('New Password Saved')}}</h3>
                </div>
                <!--Body-->
                <p class="text-xs-center" >{{t('Your password has been saved.')}}</p>
                <div class="text-xs-center p-t-2">
                  <router-link v-bind:to='loginURL' class="btn btn-success btn-lg" >{{t('Login')}}</router-link>
                </div>
              </div>
              <div v-if="!isChanged" class="card-block">

                <!--Header-->
                <div class="form-header brown darken-2">
                  <h3> {{t('Reset Password')}}</h3>
                </div>
                <!--Body-->

                <div class="card card-info text-xs-center z-depth-1 m-b-3">
                  <div class="card-block">
                    <p class="white-text">{{t('Please insert your new password')}}</p>
                  </div>
                </div>
                <div v-if="notFound" class="card card-danger text-xs-center z-depth-1 m-b-3">
                  <div class="card-block">
                    <p class="white-text">{{t('Account not found.')}}</p>
                  </div>
                </div>
                <div v-if="tokenInvalid" class="card card-warning text-xs-center z-depth-1 m-b-3">
                  <div class="card-block">
                    <p class="white-text">{{t('This page is not valid for a password reset. It\'s  probably because you used it before. Want to reset again?')}}
                    <div>
                      <router-link class="btn btn-warning-outline btn-small white-text" v-bind:to="recoverURL">{{t('recover account')}}</router-link></p>
                    </div>
                  </div>
                </div>
                <Text-Input :data="form.password" type="password"></Text-Input>
                <Text-Input :data="form.password_confirmation" type="password"></Text-Input>
                <div class="text-xs-center p-t-2">
                  <button v-if="!isResetingPassword" class="btn btn-success btn-lg" id="submitRegisterPromoter" v-on:click="resetPassword()">{{t('Change Password')}}</button>
                  <button v-if="isResetingPassword" class="btn btn-success btn-lg" v-on:click="resetPassword()"><i class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../request';
import TextInput from '../Form/V1/TextInput';
import Navigation from '../Navigation/Navigation';
import BackgroundImage from '../BackgroundImage';
// import store from '../../store';

export default {
  name: 'ResetPassword',
  components: {
    'Text-Input': TextInput,
    'Background-Image': BackgroundImage,
    Navigation,
  },
  data() {
    return {
      isResetingPassword: false,
      isChanged: false,
      unprocessable: false,
      unauthorized: false,
      notFound: false,
      tokenInvalid: false,
      form: {
        password: {
          name: 'password',
          value: '',
          label: 'New Password',
          icon: 'fa-lock',
          errors: [],
        },
        password_confirmation: {
          name: 'password_confirmation',
          value: '',
          label: 'Repeat Password',
          icon: 'fa-lock',
          errors: [],
        },
      },
    };
  },
  computed: {
    loginURL() {
      return `/${this.$store.state.language}/login`;
    },
    recoverURL() {
      return `/${this.$store.state.language}/recover`;
    },
  },
  methods: {
    resetPassword() {
      this.unprocessable = false;
      this.unauthorized = false;
      this.notFound = false;
      this.isResetingPassword = true;
      this.tokenInvalid = false;
      let token = '';
      let email = '';
      token = this.$route.query.token;
      email = this.$route.query.email;
      const URL = `${process.env.API_URL}auth/reset`;
      request.make({
        type: 'POST',
        url: URL,
        data: {
          email,
          token,
          password: this.form.password.value,
          password_confirmation: this.form.password_confirmation.value,
        },
      }, (err, res) => {
        this.isResetingPassword = false;
        if (res.status === 422) {
          const data = JSON.parse(res.text);
          if (typeof data.errors !== 'undefined') {
            const newState = this.form;
            Object.keys(newState).forEach((field) => {
              newState[field].errors = [];
              if (typeof data.errors[field] !== 'undefined') {
                newState[field].errors = data.errors[field];
              }
            });
            this.form = Object.assign({}, this.form, newState);
            if (typeof data.errors.token !== 'undefined') {
              if (data.errors.token[0] === 'The selected token is invalid.') {
                this.tokenInvalid = true;
              }
            }
          }
        } else if (res.status === 204) {
          this.isChanged = true;
        } else if (res.status === 401) { // Unauthorized
          this.unauthorized = true;
        } else if (res.status === 422) { // Unprocessable. validation errors
          this.unprocessable = true;
        } else if (res.status === 404) {
          this.notFound = true;
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
#resetPassword {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?f51ea7e6